export function isValidNumber(number) {
    return number && typeof number === 'number' && !Number.isNaN(number);
}

function roundNumber(value, decimals) {
    const roundingPrecision = Math.pow(10, decimals);

    return Math.round(value * roundingPrecision) / roundingPrecision;
}

export function formatNumber(value, decimals) {
    if (!isValidNumber(value)) {
        return '-';
    }

    if (decimals === undefined) {
        if (value > 99.99) {
            decimals = 0;
        } else {
            decimals = 2;
        }
    }

    const isNegative = value < 0;

    const roundedNumber = roundNumber(Math.abs(value), decimals);

    const digitsArray = `${roundedNumber}`.split('.')[0].split('');
    const digitsWithSpacing = digitsArray
        .map((val, index) => {
            if ((digitsArray.length - index) % 3 === 0 && index !== 0) {
                return ` ${val}`;
            }

            return val;
        })
        .join('');

    if (decimals > 0) {
        return (
            `${isNegative ? '-' : ''}${digitsWithSpacing},` +
            roundedNumber.toFixed(decimals).split('.').pop()
        );
    }

    return `${isNegative ? '-' : ''}${digitsWithSpacing}`;
}
